export default __webpack_public_path__ + "32c1228409ea34b04c32c1990abe65cd.png";